import { Component, OnInit, Input, ViewChild, Inject, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { AreasService } from '@app/services/areas/areas.service';
import { Store } from '@ngrx/store';
import * as OrganizationActions from '@app/modules/organization/store/actions/organization.actions';
import { SubSink } from 'subsink';
import { selectCurrentItemState } from '../../store/selectors/organization.selectors';
import { SanitizeStringPipe } from '@app/shared/pipes/sanitize-string.pipe';

export interface DialogData {
  type: 'Add' | 'Edit';
}

@Component({
  selector: 'app-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class FormComponent implements AfterViewInit, OnDestroy{
  public form: FormGroup;
  private id$;
  private subs: SubSink = new SubSink;
  constructor(
    private store$: Store,
    @Inject(MAT_DIALOG_DATA) public data
    ) {

      if(this.data.type === 'Add'){
        this.form = new FormGroup({
          prdAreaNameEn: new FormControl('', [Validators.required])
        });
      }else{
        this.form = new FormGroup({
          prdAreaNameEn: new FormControl(new SanitizeStringPipe().transform(this.data.area?.prdAreaNameEn), [Validators.required])
        });
      }
   }

   ngAfterViewInit(){
     this.subs.add(this.store$.select(selectCurrentItemState).subscribe(currentItem => this.id$ = currentItem?.prdAreaID ));
   }

   ngOnDestroy(){
     this.subs.unsubscribe();
   }

   onSubmit(){ 
     let prdAreaNameEn = this.form.controls['prdAreaNameEn'].value;

     if(prdAreaNameEn.trim()!='' && this.form.status === "VALID"){
      switch(this.data.type){
        case 'Add': 
          this.store$.dispatch(OrganizationActions.addArea({ form: this.form.value }));
        break;
        case 'Edit':
          this.store$.dispatch(OrganizationActions.updateArea({ form: this.form.value, prdAreaID: this.id$ }));
        break;
       }
      }
   }

   onValidateAreaName(event) {
    let prdAreaNameEn = event.target.value.trim();
    if(prdAreaNameEn==''){
      return this.form.controls['prdAreaNameEn'].setErrors({ "required" : false });
    }
  }

}

